import React from 'react';
import clsx from 'clsx';

type Tone = 'default' | 'muted' | 'accent' | 'elevated';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  tone?: Tone;
  padded?: boolean;
}

export const Card: React.FC<CardProps> = ({ tone = 'default', padded = true, className, children, ...rest }) => (
  <div
    className={clsx('ui-card', `ui-card--${tone}`, padded && 'ui-card--padded', className)}
    {...rest}
  >
    {children}
  </div>
);
